import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import DataTable from "components/DataTable";
import SoftTypography from "components/SoftTypography";
import dataRemitos from "./dataRemitos";

const Listado = memo(({ listadoRemito, ejecutarAccion, finalizado }) => {
  const { columns, getRows } = dataRemitos;
  const allRows = useMemo(
    () => getRows(listadoRemito, ejecutarAccion, finalizado),
    [listadoRemito]
  );

  return (
    <Grid
      item
      xs={12}
      sx={{
        maxHeight: "300px",
        overflowY: "auto",
      }}
      py={2}
    >
      {listadoRemito.length > 0 ? (
        <DataTable columns={columns} rows={allRows} />
      ) : (
        <Grid display="flex" justifyContent="center" py={2}>
          <SoftTypography variant="body1" color="dark">
            No hay productos seleccionados
          </SoftTypography>
        </Grid>
      )}
    </Grid>
  );
});
Listado.propTypes = {
  listadoRemito: PropTypes.array.isRequired,
  ejecutarAccion: PropTypes.func.isRequired,
  finalizado: PropTypes.bool,
};

export default Listado;
